const CASE_ONE = [
  [0, 2, 2, 1, 0, 0, 1, 1, 1],
  [1, 1, 1, 0, 1, 1, 1, 0, 0],
  [0, 0, 0, 1, 1, 1, 0, 0, 0],
  [1, 1, 1, 1, 0, 1, 0, 0, 2],
  [1, 0, 0, 0, 1, 0, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 2, 1, 1, 1, 0],
  [2, 0, 0, 0, 0, 0, 0, 1, 1]
];
const CASE_MINE = [[2,1,1],[1,1,0],[0,1,1]]

const CASE_TWO = [
  [0, 1, 0, 1, 0, 1, 0],
  [1, 1, 1, 1, 2, 1, 1],
  [0, 1, 0, 1, 0, 1, 0],
  [1, 1, 1, 1, 1, 1, 1],
  [0, 1, 0, 1, 0, 1, 0],
  [1, 1, 1, 1, 1, 1, 1],
  [0, 1, 0, 1, 0, 1, 0]
]

const CASE_THREE = [
  [1, 1, 1, 1, 2, 1, 1, 1, 1],
  [0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 1],
  [0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 2, 1, 2, 1, 1, 1, 0, 1],
  [0, 0, 0, 0, 0, 0, 0, 0, 0],
  [1, 1, 1, 1, 1, 1, 1, 1, 2],
  [0, 0, 0, 0, 1, 0, 0, 0, 0],
  [1, 0, 1, 1, 1, 1, 1, 1, 1]
]

export {
  CASE_ONE,
  CASE_TWO,
  CASE_THREE,
  CASE_MINE
}